// This file provides dummy data for layout testing when the backend isn't running.

export const mockMicrophoneData = [
  {
    name: 'fmv-sph0645-11',
    device_id: 'fmv-sph0645-11',
    events: ['human_speech', 'human_activity', 'glass_break'],
    scores: [0.95, 0.72, 0.45],
    timestamp: new Date(Date.now() - 300000).toISOString(), // 5 minutes ago
    location: '123.45,67.89'
  },
  {
    name: 'fmv-sph0645-12',
    device_id: 'fmv-sph0645-12',
    events: ['gunshot', 'explosion', 'siren'],
    scores: [0.87, 0.65, 0.58],
    timestamp: new Date(Date.now() - 240000).toISOString(), // 4 minutes ago
    location: '124.50,68.90'
  },
  {
    name: 'fmv-sph0645-13',
    device_id: 'fmv-sph0645-13',
    events: ['siren', 'vehicle_horn', 'human_speech'],
    scores: [0.92, 0.78, 0.34],
    timestamp: new Date(Date.now() - 180000).toISOString(), // 3 minutes ago
    location: '125.55,69.91'
  }
];

export const mockHistoryData = [
  {
    device_id: 'fmv-sph0645-11',
    event_name: 'human_speech',
    events: ['human_speech', 'human_activity', 'glass_break'],
    scores: [0.95, 0.72, 0.45],
    timestamp: new Date(Date.now() - 300000).toISOString(), // 5 minutes ago
    location_x: '123.45',
    location_y: '67.89'
  },
  {
    device_id: 'fmv-sph0645-12',
    event_name: 'gunshot',
    events: ['gunshot', 'explosion', 'siren'],
    scores: [0.87, 0.65, 0.58],
    timestamp: new Date(Date.now() - 240000).toISOString(), // 4 minutes ago
    location_x: '124.50',
    location_y: '68.90'
  },
  {
    device_id: 'fmv-sph0645-13',
    event_name: 'siren',
    events: ['siren', 'vehicle_horn', 'human_speech'],
    scores: [0.92, 0.78, 0.34],
    timestamp: new Date(Date.now() - 180000).toISOString(), // 3 minutes ago
    location_x: '125.55',
    location_y: '69.91'
  }
];

// Generate new mock events for live updates
export const generateNewMockEvents = () => {
  const devices = ['fmv-sph0645-11', 'fmv-sph0645-12', 'fmv-sph0645-13', 'fmv-sph0645-14'];
  const eventTypes = [
    { events: ['human_speech', 'human_activity', 'glass_break'], scores: [0.95, 0.72, 0.45] },
    { events: ['gunshot', 'explosion', 'siren'], scores: [0.87, 0.65, 0.58] },
    { events: ['siren', 'vehicle_horn', 'human_speech'], scores: [0.92, 0.78, 0.34] },
    { events: ['dog_bark', 'door_bell', 'car_alarm'], scores: [0.88, 0.73, 0.62] },
    { events: ['baby_cry', 'human_speech', 'background_noise'], scores: [0.91, 0.68, 0.41] }
  ];

  const randomDevice = devices[Math.floor(Math.random() * devices.length)];
  const randomEventType = eventTypes[Math.floor(Math.random() * eventTypes.length)];

  return {
    device_id: randomDevice,
    name: randomDevice,
    event_name: randomEventType.events[0],
    events: randomEventType.events,
    scores: randomEventType.scores,
    timestamp: new Date().toISOString(),
    location_x: (120 + Math.random() * 10).toFixed(2),
    location_y: (60 + Math.random() * 10).toFixed(2)
  };
};